import { SearchTerm } from './SearchTerm';

const AuditTypeSearch: SearchTerm [] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'nameOriginal',
        translationKey: "name"
    }
];

export default AuditTypeSearch;

